module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-table/~/babel-runtime/core-js/array/from.js
 ** module id = 1909
 ** module chunks = 3
 **/